module.exports = __webpack_public_path__ + "img/teacher_img3.5fe1213b.png";